import { LocationApiApiLocationCheckGet } from '@clients/AuthApi';

export const useVpnNotice = () => {
    const notice = ref(false);

    const authStore = useAuthStore();
    const { featureFlags, loadPromise } = storeToRefs(usePostHog());

    onBeforeMount(async () => {
        try {
            const { data } = await LocationApiApiLocationCheckGet();
            await loadPromise.value;
            const enabled = featureFlags.value?.vpnpopuptest;
            authStore.setVpn(!!data.showMessage);
            if (data.showMessage && enabled) {
                notice.value = true;
            }
        } catch {}
    });

    return notice;
};
